import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrJoinPopup', {
    title: 'Are you sure you need to set up ApprovalMax from scratch?',
    header: 'Some folks from your organization have already set up ApprovalMax. Ask them for an invite to work together!',
    newAccount: 'I need to start from scratch',
    joinToExistingAccount: 'I will ask my colleagues for an invite',
});
